export type AuthDiagnosticStage = 'load_user_info' | 'iam_exchange' | 'device_token';
export type AuthDiagnosticOutcome = 'failed' | 'fallback';
export type AuthDiagnosticErrorKind = 'http' | 'network' | 'invalid_response' | 'unknown';

export interface AuthDiagnostic {
  event: 'auth_diagnostic';
  code: 'load_user_info_failed' | 'iam_exchange_failed' | 'device_token_failed';
  stage: AuthDiagnosticStage;
  status?: number;
  outcome: AuthDiagnosticOutcome;
  hasStore?: boolean;
  hasPrimarySid?: boolean;
  hasUniqueName?: boolean;
  hasScopes?: boolean;
  errorKind: AuthDiagnosticErrorKind;
}

export interface AuthDiagnosticProfile {
  store?: unknown;
  primarysid?: unknown;
  unique_name?: unknown;
  name?: unknown;
  scopes?: unknown;
  scope?: unknown;
}

const objectValue = (value: unknown): Record<string, unknown> => value && typeof value === 'object' ? value as Record<string, unknown> : {};
const presentString = (value: unknown): boolean => typeof value === 'string' && value.trim().length > 0;

export const authDiagnostic = (stage: AuthDiagnosticStage, error: unknown, outcome: AuthDiagnosticOutcome = 'failed', profile?: AuthDiagnosticProfile): AuthDiagnostic => {
  const source = objectValue(error);
  const response = objectValue(source.response);
  const status = typeof response.status === 'number' && Number.isInteger(response.status) && response.status >= 100 && response.status <= 599 ? response.status : undefined;
  const errorKind: AuthDiagnosticErrorKind = status !== undefined
    ? 'http'
    : source.code === 'ERR_NETWORK' || source.message === 'Network Error'
      ? 'network'
      : source.response ? 'invalid_response' : 'unknown';

  const diagnostic: AuthDiagnostic = {
    event: 'auth_diagnostic',
    code: stage === 'load_user_info' ? 'load_user_info_failed' : stage === 'iam_exchange' ? 'iam_exchange_failed' : 'device_token_failed',
    stage,
    ...(status === undefined ? {} : { status }),
    outcome,
    errorKind,
  };
  if (profile) {
    const scopes = profile.scopes ?? profile.scope;
    diagnostic.hasStore = presentString(profile.store);
    diagnostic.hasPrimarySid = presentString(profile.primarysid);
    diagnostic.hasUniqueName = presentString(profile.unique_name) || presentString(profile.name);
    diagnostic.hasScopes = (Array.isArray(scopes) && scopes.length > 0) || presentString(scopes);
  }
  return diagnostic;
};